<template>
  <div class="page-header-index-wide">
    <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
      <div class="account-settings-info-main" :class="device">
        <div class="account-settings-info-left">
          <a-menu
            :mode="device == 'mobile' ? 'horizontal' : 'inline'"
            :style="{ border: '0', width: device == 'mobile' ? '560px' : 'auto'}"
            :defaultSelectedKeys="defaultSelectedKeys"
            type="inner"
            @openChange="onOpenChange"
          >
            <a-menu-item key="/project/setting/information">
              <router-link :to="{ name: 'informationsetting' }">
                项目信息
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/labeltype">
              <router-link :to="{ name: 'labeltypesetting' }">
                标注类型
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/NDPIsetting" v-show="showNDPISetting">
              <router-link :to="{ name: 'NDPIsetting' }">
                NDPI配置
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/hospital">
              <router-link :to="{ name: 'hospitalsetting' }">
                数据来源
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/label">
              <router-link :to="{ name: 'labelsetting' }">
                标注配置
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/model">
              <router-link :to="{ name: 'modelsetting' }">
                诊断模型
              </router-link>
            </a-menu-item>
            <a-menu-item key="/project/setting/danger" v-if="isProjectCreater()">
              <router-link :to="{ name: 'dangersetting' }">
                危险设置
              </router-link>
            </a-menu-item>
          </a-menu>
        </div>
        <div class="account-settings-info-right">
          <div class="account-settings-info-title">
            <span>{{ $route.meta.title }}</span>
          </div>
          <route-view></route-view>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import PageLayout from '@/components/page/PageLayout'
import RouteView from '@/components/layouts/RouteView'
import { mixinDevice } from '@/utils/mixin.js'
import { mapGetters } from 'vuex'


export default {
  components: {
    RouteView,
    PageLayout
  },
  mixins: [mixinDevice],
  data () {
    return {
      // horizontal  inline
      mode: 'inline',

      openKeys: [],
      defaultSelectedKeys: [],
      showNDPISetting: true

    }
  },

  watch: {
    isProjectCreater (yes) {
      if (yes) this.showSetting = true
      else this.showSetting = false
    },
    imageType (yes) {
      if (this.$store.getters.projectData.imageType == 'ndpi')this.showNDPISetting = true
      else this.showNDPISetting = false
    }
  },
  created () {
    this.updateMenu()
    if (this.$store.getters.projectData.imageType == 'ndpi')this.showNDPISetting = true
    else this.showNDPISetting = false
  },
  methods: {
    ...mapGetters(['isProjectCreater', 'imageType']),
    onOpenChange (openKeys) {
      this.openKeys = openKeys
    },
    updateMenu () {
      const routes = this.$route.matched.concat()
      this.defaultSelectedKeys = [ routes.pop().path ]
    }
  }
}
</script>

<style lang="less" scoped>
  .account-settings-info-main {
    width: 100%;
    display: flex;
    height: 100%;
    overflow: auto;

    &.mobile {
      display: block;

      .account-settings-info-left {
        border-right: unset;
        border-bottom: 1px solid #e8e8e8;
        width: 100%;
        height: 50px;
        overflow-x: auto;
        overflow-y: scroll;
      }
      .account-settings-info-right {
        padding: 20px 40px;
      }
    }

    .account-settings-info-left {
      border-right: 1px solid #e8e8e8;
      width: 224px;
    }

    .account-settings-info-right {
      flex: 1 1;
      padding: 8px 40px;

      .account-settings-info-title {
        color: rgba(0,0,0,.85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
      }
      .account-settings-info-view {
        padding-top: 12px;
      }
    }
  }

</style>
